import type { AppEnvironment } from './environment.type';

export const environment: AppEnvironment = {
  apiBaseUrl: 'https://api-dev.fisitalview.ai/v1',
};
